import { Component, h, Prop, Element, Host } from '@stencil/core';
import { injectCSS } from '../../utils';
import { createStyles } from './spacer-styles';
import { TSpacerDirection, TSpacerSize } from './spacer-utils';

@Component({
  tag: 'dc-ui-spacer',
  shadow: true,
})
export class DcUiSpacer {
  @Element() el: HTMLElement;
  @Prop() size: TSpacerSize = 8;
  @Prop() direction: TSpacerDirection = 'horizontal';

  render() {
    injectCSS(this.el, createStyles, this.direction, this.size);

    return <Host></Host>;
  }
}
